/*
 * @Author: cmchiu
 * @Date: 2022-09-07 17:57:21
 * @LastEditTime: 2022-10-03 10:11:29
 * @LastEditors: cmchiu
 * @Description:
 * @FilePath: \LearningMarket\LearningMarket-ClientApp\src\api\auth.js
 *
 */
import request from '@/utils/request'

export const isLogin = async () => {
    return await request({
        url: `${process.env.VUE_APP_CampusAPIURL}CurrentLogin/IsLogin`,
        method: 'get',
    })
}

export const getLogName = async () => {
    return await request({
        url: `${process.env.VUE_APP_CampusAPIURL}CurrentLogin/GetLogName`,
        method: 'get',
    })
}

export const getCurrentMan = async () => {
    return await request({
        url: `${process.env.VUE_APP_CampusAPIURL}ManAdapter/GetCurrentMan`,
        method: 'get',
    })
}

export const getAcpdById = async params => {
    return await request({
        url: `${process.env.VUE_APP_CampusAPIURL}Acpd/GetAcpdById`,
        method: 'get',
        params,
    })
}

export const checkCampusIsLogged = async () => {
    return await request({
        url: `Auth/CheckCampusIsLogged`,
        method: 'post',
    })
}

export const logoutLM = async () => {
    return await request({
        url: `Auth/LogoutLM`,
        method: 'get',
    })
}

const auth = {
    isLogin,
    getLogName,
    // setLogin,
    // setLoginWithExpire,
    // setLogout,
    // checkLogin,
    // updateSucessLogIn,
    // updateFailLogIn,
    // manLogout,
    // manLogin,
    getCurrentMan,
    getAcpdById,
    checkCampusIsLogged,
    logoutLM,
}
export default auth
